export class LoginData {
    public passwordEnabled: boolean;
    public loginEnabled: boolean;
    public deviceId: string;
}